import { render, staticRenderFns } from "./LaborProtectionAccidents.vue?vue&type=template&id=0e2dc008&"
import script from "./LaborProtectionAccidents.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionAccidents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports